export { default } from "./tabObjectsContainer";
